import React, { useRef } from 'react';
import ChatTalentCard from './ChatTalentCard';

const TalentCardCarousel = ({ talents }) => {
  const scrollContainerRef = useRef(null);
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    const slider = scrollContainerRef.current;
    if (!slider) return;

    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    slider.classList.add('cursor-grabbing');
    slider.classList.remove('cursor-grab');
    // Prevent text selection during drag
    e.preventDefault();
  };

  const handleMouseLeave = () => {
    isDown = false;
    const slider = scrollContainerRef.current;
    if (slider) {
      slider.classList.remove('cursor-grabbing');
      slider.classList.add('cursor-grab');
    }
  };

  const handleMouseUp = () => {
    isDown = false;
    const slider = scrollContainerRef.current;
    if (slider) {
      slider.classList.remove('cursor-grabbing');
      slider.classList.add('cursor-grab');
    }
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    const slider = scrollContainerRef.current;
    if (!slider) return;
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="w-full my-8">
      <div
        ref={scrollContainerRef}
        className="flex gap-8 overflow-x-auto pb-4 hide-scrollbar touch-pan-x cursor-grab select-none"
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
      >
        {talents.map((talent, idx) => (
          <div
            key={talent.id || idx}
            className="min-w-[350px] max-w-[500px] w-full flex-shrink-0"
          >
            <ChatTalentCard content={talent} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TalentCardCarousel; 